import PropTypes from 'prop-types'
import React from 'react'

import MorePropTypes from '../../common/MorePropTypes'
import levelClub from './level_club.png'
import levelGold from './level_gold.png'
import levelNone from './level_none.png'
import levelPlatinum from './level_platinum.png'
import levelSilver from './level_silver.png'

const levelToImage = {
  NONE: levelNone,
  INACTIVE: levelClub,
  BRONZE: levelClub,
  CLUB: levelClub,
  GOLD: levelGold,
  SILVER: levelSilver,
  PLATINUM: levelPlatinum
}

export default function ClubOneCardIcon({ className, level }) {
  const src = levelToImage[level] || levelToImage.NONE

  return <img alt="" aria-hidden className={className} src={src} />
}

ClubOneCardIcon.propTypes = {
  className: MorePropTypes.className,
  level: PropTypes.oneOf(Object.keys(levelToImage)).isRequired
}
